import { useEffect } from 'react';
import { rootContainer } from 'app/shadowRoot';

import useNamespacedStorage from './storage/useNamespacedStorage';

export default function useExternalId() {
  const [externalId, setExternalId] = useNamespacedStorage('tailor_external_id');

  useEffect(() => {
    const handleSetExternalId = (event: Event & { detail: string }) => {
      setExternalId(event.detail);
    };

    rootContainer.addEventListener('tailor:set-external-id', handleSetExternalId as EventListener);

    return () => {
      rootContainer.removeEventListener('tailor:set-external-id', handleSetExternalId as EventListener);
    };
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  return externalId;
}
